import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const DateHeaderContainer = styled.span<{ $isToday: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  ${({ $isToday, theme }) =>
    $isToday &&
    css`
      color: ${theme.palette.text.primary};
    `};
`;

export const CalendarDayBadge = styled.span<{ $isToday: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  display: inline-block;
  text-align: center;

  ${({ $isToday }) =>
    $isToday &&
    css`
      padding: ${({ theme }) => `0 ${theme.spacing(1)}`};
      background: ${({ theme }) => theme.palette.error.main};
      color: ${({ theme }) => theme.palette.error.contrastText};
      border-radius: ${({ theme }) => theme.spacing(1.5)};
      min-width: 2rem;
    `};
`;
